export class Skill {
  id: number;
  code: string;
  name: string;
  concat: boolean;
  skills: Skill[];
}
